import { useUser } from "@/components/UserProvider";
import { ContextMenuItem } from "@/components/ui";
import { useGlobalModal } from "@/hooks/useGlobalModal";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import type { Matter, MatterDocumentSubItem } from "@/lib/types";
import { FileSignatureRequestIcon } from "@/lib/utils/iconUtils";

interface MatterSubItemCreateSignatureRequestContextMenuProps {
  matter: Matter;
  subItem: MatterDocumentSubItem;
}

export const MatterSubItemCreateSignatureRequestContextMenu = ({
  matter,
  subItem,
}: MatterSubItemCreateSignatureRequestContextMenuProps) => {
  const { hasActionPermission } = useUser();
  const { openCreateSignatureRequestModal } = useGlobalModal();
  const canCreateSignatureRequest = hasActionPermission(
    ACTION_PERMISSION_KEYS.matterSignatureRequest,
    ACTION_PERMISSION_VALUES.create,
  );

  if (!canCreateSignatureRequest) return null;

  return (
    <ContextMenuItem
      onSelect={() => {
        openCreateSignatureRequestModal({ matterId: matter.id, subItem });
      }}
    >
      <FileSignatureRequestIcon />
      Create Signature Request
    </ContextMenuItem>
  );
};
